'use strict';

var a17helpers = require('./dist/prod');

module.exports = a17helpers;
